module.exports = __webpack_public_path__ + "static/media/PassportBacka.5d9380cf.png";